<script>
// Silence
</script>

<style lang="scss">
  @use '@/scss/global/buttons';
  @use '@/scss/global/drupal-helper';
  @use '@/scss/global/media';
  @use '@/scss/global/tailwind';
  @use '@/scss/global/type';

  @use '@/scss/paragraphs/alert';
  @use '@/scss/paragraphs/cta-button';
  @use '@/scss/paragraphs/count';
  @use '@/scss/paragraphs/detail-list';
  @use '@/scss/paragraphs/facts';
  @use '@/scss/paragraphs/standout-text';

  @use '@/scss/templates/blog';
  @use '@/scss/templates/case-study';
  @use '@/scss/templates/certificates';
  @use '@/scss/templates/courses';
  @use '@/scss/templates/customer';
  @use '@/scss/templates/customer-quote';
  @use '@/scss/templates/dashboard';
  @use '@/scss/templates/download';
  @use '@/scss/templates/event';
  @use '@/scss/templates/footer';
  @use '@/scss/templates/landingpage';
  @use '@/scss/templates/location';
  @use '@/scss/templates/member';
  @use '@/scss/templates/node-teaser';
  @use '@/scss/templates/testimonial';

</style>
